// extracted by mini-css-extract-plugin
module.exports = {"logo":"index_logo_2b03f","logoContainer":"index_logoContainer_Kmwo1","icon":"index_icon_3ksX0"};